export const UPDATE_VENUE_FAQS_ENDPOINT = '/v1/venue/faqs';

/**
 * Shared limits enforced by both the FAQ editor (Zod schema) and the API route,
 * so the server never trusts the client-side validation alone.
 */
export const MAX_FAQS = 20;
export const MAX_FAQ_QUESTION_LENGTH = 200;
export const MAX_FAQ_ANSWER_LENGTH = 2000;

/** A single question/answer pair as submitted from the FAQ editor. */
export interface VenueFaqInput {
  question: string;
  answer: string;
}

/**
 * Request body for the FAQ update endpoint. The venue is resolved server-side
 * from the authenticated viewer's `adminVenueId`, so it is intentionally not
 * part of the payload.
 */
export interface UpdateVenueFaqsPayload {
  faqs: VenueFaqInput[];
}

export interface UpdateVenueFaqsResponse {
  success: boolean;
  message: string;
}
